import { styled } from '@mui/system';

export const Header = styled('header')`
    margin: 0 auto;
`;

export const Logo = styled('div')`
    display: flex;
    align-items: center;

    span {
        margin-left: 16px;
        font-size: 1.2rem;
        color: #000;
    }
`;
